
    (function() {
      var root = document.getElementById('concept-template--20782090715178__home_change_NKDjyB');
      if (!root || root.dataset.conceptReady === 'true') return;
      root.dataset.conceptReady = 'true';

      var navItems  = root.querySelectorAll('[data-concept-target]');
      var navGroups = root.querySelectorAll('[data-concept-group]');
      var copyCards = root.querySelectorAll('[data-concept-copy]');
      var bgLayers  = root.querySelectorAll('[data-concept-bg]');
      var prevArrows = root.querySelectorAll('[data-concept-prev]');
      var nextArrows = root.querySelectorAll('[data-concept-next]');

      if (!navItems.length) return;

      var currentBlockId = null;
      var firstBlockId = navItems[0].getAttribute('data-concept-target');

      function getBlockIndex(id) {
        for (var i = 0; i < navItems.length; i++) {
          if (navItems[i].getAttribute('data-concept-target') === id) return i;
        }
        return null;
      }

      function getSiblingBlockId(fromId, direction) {
        var idx = getBlockIndex(fromId);
        if (idx === null) return null;
        idx += direction;
        if (idx < 0 || idx >= navItems.length) return null;
        return navItems[idx].getAttribute('data-concept-target');
      }

      function updateArrowState() {
        var idx = getBlockIndex(currentBlockId);
        var last = navItems.length - 1;
        var atStart = idx === null || idx <= 0;
        var atEnd = idx === null || idx >= last;

        prevArrows.forEach(function(btn) { btn.disabled = atStart; });
        nextArrows.forEach(function(btn) { btn.disabled = atEnd; });
      }

      function setActiveBlock(id) {
        if (!id || id === currentBlockId) return;
        currentBlockId = id;

        var activeIndex = getBlockIndex(id);
        if (activeIndex !== null) {
          root.style.setProperty('--concept-index', activeIndex);
        }

        navItems.forEach(function(btn) {
          var on = btn.getAttribute('data-concept-target') === id;
          btn.setAttribute('aria-selected', on ? 'true' : 'false');
          btn.setAttribute('aria-expanded', on ? 'true' : 'false');
        });

        navGroups.forEach(function(group) {
          var on = group.getAttribute('data-concept-group') === id;
          group.classList.toggle('is-active', on);
        });

        copyCards.forEach(function(card) {
          var on = card.getAttribute('data-concept-copy') === id;
          card.setAttribute('aria-hidden', on ? 'false' : 'true');
        });

        bgLayers.forEach(function(layer) {
          var on = layer.getAttribute('data-concept-bg') === id;
          var video = layer.querySelector('video');
          if (!video) return;
          if (on) {
            try { video.currentTime = 0; } catch (e) {}
            if (video.play) {
              var p = video.play();
              if (p && typeof p.catch === 'function') p.catch(function() {});
            }
          } else if (video.pause) {
            video.pause();
          }
        });

        updateArrowState();
      }

      function goToSibling(direction) {
        var targetId = getSiblingBlockId(currentBlockId, direction);
        if (targetId) setActiveBlock(targetId);
      }

      navItems.forEach(function(btn) {
        btn.addEventListener('click', function() {
          var id = this.getAttribute('data-concept-target');
          if (id) setActiveBlock(id);
        });

        btn.addEventListener('keydown', function(e) {
          var list = Array.prototype.slice.call(navItems);
          var idx = list.indexOf(this);
          if (idx === -1) return;

          if (e.key === 'ArrowDown' || e.key === 'ArrowRight') {
            e.preventDefault();
            idx += 1;
          } else if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') {
            e.preventDefault();
            idx -= 1;
          } else if (e.key === 'Home') {
            e.preventDefault();
            idx = 0;
          } else if (e.key === 'End') {
            e.preventDefault();
            idx = list.length - 1;
          } else {
            return;
          }

          if (idx < 0 || idx >= list.length) return;
          var next = list[idx];
          next.focus();
          var id = next.getAttribute('data-concept-target');
          if (id) setActiveBlock(id);
        });
      });

      prevArrows.forEach(function(btn) {
        btn.addEventListener('click', function() { goToSibling(-1); });
      });

      nextArrows.forEach(function(btn) {
        btn.addEventListener('click', function() { goToSibling(1); });
      });

      var swipeSurface = root.querySelector('.t-concept__shell');
      if (swipeSurface) {
        var touchStartX = 0;
        var touchStartY = 0;
        var touchTracking = false;

        swipeSurface.addEventListener('touchstart', function(e) {
          if (!e.touches || e.touches.length !== 1) return;
          touchStartX = e.touches[0].clientX;
          touchStartY = e.touches[0].clientY;
          touchTracking = true;
        }, { passive: true });

        swipeSurface.addEventListener('touchend', function(e) {
          if (!touchTracking) return;
          touchTracking = false;
          var touch = e.changedTouches && e.changedTouches[0];
          if (!touch) return;
          var dx = touch.clientX - touchStartX;
          var dy = touch.clientY - touchStartY;
          if (Math.abs(dx) < 40 || Math.abs(dx) <= Math.abs(dy)) return;
          goToSibling(dx < 0 ? 1 : -1);
        }, { passive: true });
      }

      setActiveBlock(firstBlockId);
    })();
